import { FacilityScreenState } from './reducer'

export const getFacilityScreenRows = (state: { facilityScreen: FacilityScreenState }) =>
  state.facilityScreen.rows

export const getFacilityScreenLoader = (state: { facilityScreen: FacilityScreenState }) =>
  state.facilityScreen.isLoading

export const isFacilityScreenStale = (state: { facilityScreen: FacilityScreenState }) =>
  state.facilityScreen.stale
